import React from 'react';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';
import { Link } from 'react-router-dom';
import { Link as MuiLink } from '@mui/material';
import { editPostPath } from '../../../Utils/routes';
import useSpace from '../../../Hooks/useSpace';

function ParentWarning({ post }: any) {
  const { space } = useSpace();
  const parent = get(post, 'included.source');

  return (
    <FormattedMessage
      id="PUBLISHING_POST_DIALOG.PARENT_WARNING"
      values={{
        link: (
          <MuiLink component={Link} to={editPostPath(space.slug, parent.slug, parent.type)}>
            {parent.title}
          </MuiLink>
        ),
      }}
    />
  );
}

export default ParentWarning;
